<template>
    <div v-if="ready">
        <PowerApp :app="app" :entrypoint="appConfig.onboarding" :dist="settings.dist" noRouter @onboardingSuccess="onboardingSuccess" @save="saveAppSettings" :config="config" v-if="appConfig.onboarding"/>
        <b-alert show variant="danger"> {{ $t('unexpectedError') }} </b-alert>
    </div>
    
    <b-skeleton width="100%" height="250px" animation="throb" v-else />
</template>

<script>
import { get, set } from 'lodash'
import PowerApp from './PowerApp'

export default {
    components: {
        PowerApp
    },

    props: {
        id: {
            type: String
        }
    },

    data: () => {
        return {
            ready: false,
            app: null
        }
    },

    methods: {
        onboardingSuccess() {
            this.$http.put(`/v3/system/gateway/app-service/app/${this.id}/settings`, {'config.onboarding.finished': true})
            .then(() => {
                this.$emit('onboardingSuccess', 'app', this.id)
            }).catch(err => {
                this.$debugLog(err)
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })
            })
        },

        save() {
            let popup = this.$loadingPopup()
            this.$http.put(`/v3/system/gateway/app-service/app/${this.$route.params.id}/settings`, this.app).catch(err => {
                this.$debugLog(err)
                this.$bvToast.toast("Failed to save app settings.", {
                    variant: 'danger'
                })
            }).finally(() => popup.hide())
        },

        saveAppSettings(config) {
            set(this.app, "config.env.live", config)

            this.save()
        },
    },

    computed: {
        appConfig() {
            if (this.settings && this.settings.dist && this.settings.dist['views.json'])
                return JSON.parse(this.settings.dist['views.json'] || '{}')

            return {}
        },


        settings() {
            return this.app.settings.find(s => {
                return s.version == this.app.public_version
            })
        },

        config() {
            return get(this.app, "config.env.live", {})
        },
    },

    async mounted() {
        this.$http.get(`/v3/system/gateway/app-service/app/${this.id}/settings`).then(resp => {
            this.app = resp.data
            this.ready = true
       }).catch(err => {
           this.$debugLog(err)
           this.$bvModal.msgBoxOk("Failed to fetch app.")
       })

    }
}
</script>